(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["haus-era-banner"] && !Shopify.designMode) return;
  try {
    
(function() {
  const PALETTES = {
    alleras:    ['#fd61fe', '#fd029d', '#6a28f3', '#69f8e5', '#ffffff'],
    showgirl:   ['#d63f00', '#e25923', '#e98b5b', '#40816d', '#8dd3c6'],
    lover:      ['#fd61fe', '#fd029d', '#fde7ff', '#dad4fe', '#ffffff'],
    midnights:  ['#3424c7', '#6a28f3', '#dad4fe', '#69f8e5', '#ffffff'],
    '1989':     ['#0095ff', '#69f8e5', '#f0ffae', '#ffffff', '#fd61fe'],
    folklore:   ['#8a9a84', '#4a5a4e', '#dad4fe', '#f0ffae', '#ffffff'],
    ttpd:       ['#a89d8e', '#6a6a7a', '#dad4fe', '#fd029d', '#ffffff'],
    reputation: ['#ffffff', '#adfc02', '#fd029d', '#3424c7'],
    red:        ['#df1300', '#d49152', '#f5d98f', '#fd029d', '#ffffff'],
    speaknow:   ['#7a3fb8', '#c8a8e8', '#fd61fe', '#ffffff'],
    evermore:   ['#d49152', '#8a4f2a', '#f5d98f', '#ffffff'],
    fearless:   ['#d4a952', '#f5d98f', '#ffffff', '#fd029d'],
    default:    ['#fd029d', '#fd61fe', '#6a28f3', '#adfc02', '#ffffff']
  };

  function shouldRun(canvas) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    if (canvas.dataset.glitterOnce === '1') {
      const key = 'hausGlitter:' + (canvas.dataset.glitterKey || 'default');
      try {
        if (sessionStorage.getItem(key)) return false;
        sessionStorage.setItem(key, '1');
      } catch (e) { /* sessionStorage blocked — let it run */ }
    }
    return true;
  }

  function rand(min, max) { return min + Math.random() * (max - min); }

  function initGlitter(canvas) {
    if (canvas.__glitterInit) return;
    canvas.__glitterInit = true;
    if (!shouldRun(canvas)) { canvas.remove(); return; }

    const ctx = canvas.getContext('2d');
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    let W = window.innerWidth, H = window.innerHeight;

    function resize() {
      W = window.innerWidth; H = window.innerHeight;
      canvas.width = W * dpr;
      canvas.height = H * dpr;
      canvas.style.width = W + 'px';
      canvas.style.height = H + 'px';
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.scale(dpr, dpr);
    }
    resize();
    window.addEventListener('resize', resize);

    const preset = canvas.dataset.glitterPreset || 'default';
    const palette = PALETTES[preset] || PALETTES.default;
    const COUNT = parseInt(canvas.dataset.glitterCount, 10) || 60;
    const DURATION = parseInt(canvas.dataset.glitterDuration, 10) || 5000;

    const particles = [];
    for (let i = 0; i < COUNT; i++) {
      particles.push({
        x: Math.random() * W,
        y: -rand(50, H * 0.6) - Math.random() * 200,
        size: rand(2, 7),
        color: palette[Math.floor(Math.random() * palette.length)],
        vy: rand(0.8, 2.6),
        vx: rand(-0.6, 0.6),
        rot: Math.random() * Math.PI * 2,
        vrot: rand(-0.08, 0.08),
        twinklePhase: Math.random() * Math.PI * 2,
        twinkleSpeed: rand(0.04, 0.12),
        baseOpacity: rand(0.6, 1)
      });
    }

    const startTime = performance.now();

    function draw(now) {
      const elapsed = now - startTime;
      const progress = elapsed / DURATION;
      ctx.clearRect(0, 0, W, H);

      let visible = 0;
      for (let i = 0; i < particles.length; i++) {
        const p = particles[i];
        p.y += p.vy;
        p.x += p.vx;
        p.rot += p.vrot;
        p.twinklePhase += p.twinkleSpeed;

        let layerOpacity = 1;
        if (progress > 0.75) layerOpacity = Math.max(0, 1 - (progress - 0.75) / 0.25);

        const twinkle = 0.65 + 0.35 * Math.sin(p.twinklePhase);
        const opacity = p.baseOpacity * twinkle * layerOpacity;

        if (p.y > H + 30 || opacity < 0.02) continue;

        visible++;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.globalAlpha = opacity;
        ctx.fillStyle = p.color;
        ctx.beginPath();
        ctx.moveTo(0, -p.size);
        ctx.lineTo(p.size * 0.6, 0);
        ctx.lineTo(0, p.size);
        ctx.lineTo(-p.size * 0.6, 0);
        ctx.closePath();
        ctx.fill();
        ctx.globalAlpha = opacity;
        ctx.fillStyle = '#ffffff';
        ctx.beginPath();
        ctx.arc(0, 0, p.size * 0.2, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      }

      if (visible > 0 && progress < 1.05) {
        requestAnimationFrame(draw);
      } else {
        window.removeEventListener('resize', resize);
        canvas.remove();
      }
    }

    requestAnimationFrame(draw);
  }

  function init() {
    document.querySelectorAll('[data-era-glitter]').forEach(initGlitter);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haus-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  class HausAlbumHero {
    constructor(el) {
      this.el = el;
      this.autoRotate = el.dataset.autoRotate === '1';
      this.stopOnClick = el.dataset.stopOnClick === '1';
      this.rotateInterval = parseInt(el.dataset.rotateInterval, 10) || 4500;
      this.chips = [...el.querySelectorAll('.era-chip')];
      if (!this.chips.length) return;

      this.card = el.querySelector('[data-player-card]');
      this.cover = el.querySelector('[data-player-cover]');
      this.metaEra = el.querySelector('[data-meta-era]');
      this.metaSub = el.querySelector('[data-meta-sub]');
      this.badge = el.querySelector('[data-player-badge]');
      this.progressCount = el.querySelector('[data-progress-count]');
      this.progressFill = el.querySelector('[data-progress-fill]');

      this.currentIndex = 0;
      this.timer = null;
      this.baseProgress = parseInt(el.dataset.progressPercent, 10) || 37;
      this.userLocked = false;

      this.bindEvents();
      if (this.autoRotate) this.startRotate();
    }

    bindEvents() {
      this.chips.forEach((chip, i) => {
        chip.addEventListener('click', (e) => {
          if (e.metaKey || e.ctrlKey || e.shiftKey) return;
          e.preventDefault();
          this.switchTo(i);
          if (this.stopOnClick) {
            this.userLocked = true;
            this.stopRotate();
          }
        });
      });

      const prevBtn = this.el.querySelector('[data-player-prev]');
      const nextBtn = this.el.querySelector('[data-player-next]');
      const playBtn = this.el.querySelector('[data-player-play]');

      if (prevBtn) prevBtn.addEventListener('click', (e) => {
        e.preventDefault(); e.stopPropagation();
        this.switchTo((this.currentIndex - 1 + this.chips.length) % this.chips.length);
      });

      if (nextBtn) nextBtn.addEventListener('click', (e) => {
        e.preventDefault(); e.stopPropagation();
        this.switchTo((this.currentIndex + 1) % this.chips.length);
      });

      if (playBtn) playBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        const link = this.chips[this.currentIndex].dataset.link;
        if (link && link !== '#') {
          e.preventDefault();
          window.location = link;
        }
      });

      if (this.card) {
        this.card.addEventListener('mouseenter', () => {
          if (this.timer) this.stopRotate();
        });
        this.card.addEventListener('mouseleave', () => {
          if (this.autoRotate && !this.userLocked) this.startRotate();
        });
      }
    }

    switchTo(index) {
      if (index === this.currentIndex) return;
      this.currentIndex = index;
      const chip = this.chips[index];
      if (!chip) return;

      const name = chip.dataset.eraName || '';
      const preset = chip.dataset.eraPreset || 'lover';
      const meta = chip.dataset.meta || '';
      const image = chip.dataset.image || '';
      const cardBg = chip.dataset.cardBg || '';
      const link = chip.dataset.link || '#';

      if (this.card && this.card.tagName === 'A') {
        this.card.setAttribute('href', link);
      }

      if (this.card) {
        this.card.style.background = cardBg || '';
      }

      if (this.cover) {
        this.cover.style.opacity = '0';
        setTimeout(() => {
          this.cover.className = this.cover.className
            .split(' ')
            .filter(c => !c.startsWith('era-'))
            .concat(['player-cover', 'era-' + preset])
            .join(' ');

          if (image) {
            this.cover.style.backgroundImage = 'url(' + image + ')';
            this.cover.style.backgroundSize = 'cover';
            this.cover.style.backgroundPosition = 'center';
          } else {
            this.cover.style.backgroundImage = '';
          }
          this.cover.style.opacity = '1';
        }, 180);
      }

      if (this.metaEra) this.metaEra.textContent = name;
      if (this.metaSub) this.metaSub.textContent = meta;
      if (this.badge) this.badge.textContent = (index + 1) + '/' + this.chips.length;
      if (this.progressCount) this.progressCount.textContent = 'Track ' + (index + 1) + ' of ' + this.chips.length;

      if (this.progressFill) {
        const base = this.baseProgress;
        const per = (100 - base) / Math.max(this.chips.length - 1, 1);
        this.progressFill.style.width = Math.min(100, base + (index * per)) + '%';
      }

      this.chips.forEach(c => c.classList.remove('is-active'));
      chip.classList.add('is-active');
    }

    startRotate() {
      this.stopRotate();
      this.timer = setInterval(() => {
        if (document.hidden) return;
        this.switchTo((this.currentIndex + 1) % this.chips.length);
      }, this.rotateInterval);
    }

    stopRotate() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  }

  function init() {
    document.querySelectorAll('[data-haus-hero]').forEach(el => {
      if (el.__hausInit) return;
      el.__hausInit = true;
      new HausAlbumHero(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haus-poster-buy-box"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('[data-haus-buy-box]').forEach(initBuyBox);

  function initBuyBox(root) {
    const mainImg = root.querySelector('#poster-buy-main-img');
    const thumbs = root.querySelectorAll('[data-buy-thumb]');
    const sizeCards = root.querySelectorAll('[data-buy-size]');
    const variantInput = root.querySelector('[data-buy-variant-input]');
    const priceEl = root.querySelector('[data-buy-price]');
    const pricePrefix = root.querySelector('[data-buy-price-prefix]');
    const selectedLabel = root.querySelector('[data-buy-selected-label]');
    const atcBtn = root.querySelector('[data-buy-atc]');
    const atcText = root.querySelector('[data-buy-atc-text]');
    const qtyInput = root.querySelector('[data-buy-qty]');
    const qtyDec = root.querySelector('[data-qty-decrease]');
    const qtyInc = root.querySelector('[data-qty-increase]');

    // Thumbnail swap
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        const src = thumb.dataset.src;
        const alt = thumb.dataset.alt;
        if (mainImg && src) {
          mainImg.src = src;
          if (alt) mainImg.alt = alt;
        }
        thumbs.forEach(function(t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    // Size card selection
    sizeCards.forEach(function(card) {
      card.addEventListener('click', function() {
        if (card.dataset.variantAvailable === 'false') return;
        sizeCards.forEach(function(c) {
          c.classList.remove('is-selected');
          c.setAttribute('aria-checked', 'false');
        });
        card.classList.add('is-selected');
        card.setAttribute('aria-checked', 'true');

        if (variantInput) variantInput.value = card.dataset.variantId;
        if (priceEl) priceEl.textContent = card.dataset.variantPrice;
        if (pricePrefix) pricePrefix.style.display = 'none';
        if (selectedLabel) selectedLabel.textContent = card.dataset.variantLabel;

        // Update URL so refresh keeps the size
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', card.dataset.variantId);
          window.history.replaceState({}, '', url.toString());
        } catch (e) { /* no-op */ }

        // Notify other modules (sticky bar listens to this)
        root.dispatchEvent(new CustomEvent('haus:variantchange', {
          bubbles: true,
          detail: {
            variantId: card.dataset.variantId,
            price: card.dataset.variantPrice,
            label: card.dataset.variantLabel,
            available: card.dataset.variantAvailable !== 'false'
          }
        }));

        if (atcBtn) {
          const isAvail = card.dataset.variantAvailable !== 'false';
          atcBtn.disabled = !isAvail;
          if (atcText) {
            atcText.textContent = isAvail
              ? (atcBtn.dataset.atcLabel || atcText.textContent)
              : (atcBtn.dataset.soldoutLabel || atcText.textContent);
          }
        }
      });
    });

    // Quantity buttons
    if (qtyInput) {
      if (qtyDec) qtyDec.addEventListener('click', function() {
        const v = parseInt(qtyInput.value, 10) || 1;
        if (v > 1) qtyInput.value = v - 1;
      });
      if (qtyInc) qtyInc.addEventListener('click', function() {
        const v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = v + 1;
      });
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haus-poster-sticky-atc-bar"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('[data-haus-sticky]').forEach(initSticky);

  function initSticky(root) {
    const sizeEl = root.querySelector('[data-sticky-size]');
    const priceEl = root.querySelector('[data-sticky-price]');
    const variantInput = root.querySelector('[data-sticky-variant-input]');
    const atcBtn = root.querySelector('[data-sticky-atc]');

    // Listen for variant changes from the buy box
    document.addEventListener('haus:variantchange', function(e) {
      const d = e.detail || {};
      if (variantInput && d.variantId) variantInput.value = d.variantId;
      if (priceEl && d.price) priceEl.textContent = d.price;
      if (sizeEl && d.label) sizeEl.textContent = d.label;
      if (atcBtn) atcBtn.disabled = !d.available;
    });

    // Show after scrolling past hero
    const threshold = 600;
    let visible = false;
    function onScroll() {
      const shouldShow = window.scrollY > threshold;
      if (shouldShow !== visible) {
        visible = shouldShow;
        root.classList.toggle('is-visible', visible);
        root.setAttribute('aria-hidden', visible ? 'false' : 'true');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haus-puzzle-buy-box"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('[data-haus-puzzle-buy]').forEach(initBuyBox);

  function initBuyBox(root) {
    const dataEl = root.querySelector('[data-buy-variants]');
    let variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }

    const heroImg = root.querySelector('#puzzle-buy-hero-img');
    const thumbs = root.querySelectorAll('[data-buy-thumb]');
    const variantInput = root.querySelector('[data-buy-variant-input]');
    const priceEl = root.querySelector('[data-buy-price]');
    const priceOnBtn = root.querySelector('[data-buy-add-price]');
    const installmentEl = root.querySelector('[data-buy-installments]');
    const stockWrap = root.querySelector('[data-buy-stock]');
    const stockText = root.querySelector('[data-buy-stock-text]');
    const atcBtn = root.querySelector('[data-buy-atc]');
    const atcText = root.querySelector('[data-buy-atc-text]');
    const qtyInput = root.querySelector('[data-buy-qty]');
    const qtyDec = root.querySelector('[data-qty-decrease]');
    const qtyInc = root.querySelector('[data-qty-increase]');

    // Selected option state — one per option index
    const selected = {};
    const currentId = parseInt(variantInput.value, 10);
    const currentVariant = variants.find(v => v.id === currentId);
    if (currentVariant) {
      currentVariant.options.forEach((val, i) => { selected[i] = val; });
    }

    // Thumbnails
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        if (heroImg && thumb.dataset.src) {
          heroImg.src = thumb.dataset.src;
          if (thumb.dataset.alt) heroImg.alt = thumb.dataset.alt;
        }
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

    // Option pills
    const pillGroups = root.querySelectorAll('[data-buy-opt-group]');
    pillGroups.forEach(function(group) {
      const idx = parseInt(group.dataset.buyOptGroup, 10);
      group.querySelectorAll('[data-buy-opt-value]').forEach(function(pill) {
        pill.addEventListener('click', function() {
          if (pill.classList.contains('is-soldout')) return;
          selected[idx] = pill.dataset.optValue;
          group.querySelectorAll('[data-buy-opt-value]').forEach(p => {
            p.classList.remove('is-active');
            p.setAttribute('aria-checked', 'false');
          });
          pill.classList.add('is-active');
          pill.setAttribute('aria-checked', 'true');
          const selLabel = root.querySelector('[data-buy-opt-selected="' + idx + '"]');
          if (selLabel) selLabel.textContent = pill.dataset.optValue;
          syncVariant();
        });
      });
    });

    function findVariant() {
      return variants.find(v => v.options.every((val, i) => selected[i] === val));
    }

    function markUnavailable() {
      // For each pill, check if any variant exists with that value + current other selections
      pillGroups.forEach(function(group) {
        const idx = parseInt(group.dataset.buyOptGroup, 10);
        group.querySelectorAll('[data-buy-opt-value]').forEach(function(pill) {
          const testSel = Object.assign({}, selected, { [idx]: pill.dataset.optValue });
          const match = variants.find(v => v.options.every((val, i) => testSel[i] === val));
          if (!match || !match.available) {
            pill.classList.add('is-soldout');
          } else {
            pill.classList.remove('is-soldout');
          }
        });
      });
    }

    function syncVariant() {
      const v = findVariant();
      if (!v) return;
      variantInput.value = v.id;
      if (priceEl) priceEl.textContent = v.priceFormatted;
      if (priceOnBtn) priceOnBtn.textContent = '· ' + v.priceFormatted;
      if (installmentEl) {
        installmentEl.textContent = installmentEl.textContent.replace(
          /(\$|£|€)[\d.,]+/,
          v.installmentFormatted
        );
      }
      if (v.featured_media && heroImg) {
        heroImg.src = v.featured_media.src;
        if (v.featured_media.alt) heroImg.alt = v.featured_media.alt;
      }
      if (stockWrap) {
        stockWrap.classList.toggle('is-out', !v.available);
      }
      if (atcBtn) {
        atcBtn.disabled = !v.available;
        if (atcText) {
          atcText.textContent = v.available
            ? (atcBtn.dataset.atcLabel || atcText.textContent)
            : (atcBtn.dataset.soldoutLabel || atcText.textContent);
        }
      }
      // URL update
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* no-op */ }

      markUnavailable();
    }

    if (qtyInput) {
      if (qtyDec) qtyDec.addEventListener('click', function() {
        const val = parseInt(qtyInput.value, 10) || 1;
        if (val > 1) qtyInput.value = val - 1;
      });
      if (qtyInc) qtyInc.addEventListener('click', function() {
        const val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = val + 1;
      });
    }

    markUnavailable();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
